<template>
	<div class="flexCol alit">
		<div class="flexCol alit justc top-bg">
			<div class="flexCol alit textbg">
				<div class="commpany-name">千广遥感</div>
				<div class="commpany-desc">
					千广科技作为智慧农业领域的国资专精特新企业，低空技术+农业应用通过天空地一体化遥感监测、人工智能算法及大数据分析技术，构建覆盖农业生产全链条的数字化管理平台。通过五年的持续研发投入，整合卫星遥感、无人机低空巡查、地面物联感知和广积粮大模型算法，形成“天空地用”四位一体数据采集、分析体系，为地方政府提供农情监测与灾害预警支持，为农业经营主体提供标准化种植管理工具，为行业、社会化服务组织及金融机构搭建数字化协作平台，实现推动农业生产降本增效、资源集约利用与生态可持续发展，助力乡村振兴战略实施。
				</div>
				<div class="commpany-desc-us">
					As a state-owned specialized, sophisticated, and innovative enterprise in the field of smart agriculture, Qianguang Technology leverages its "low-altitude technology + agricultural applications" to construct a digital management platform covering the entire agricultural production chain. This is achieved through integrated air-space-ground remote sensing monitoring, artificial intelligence algorithms, and big data analysis technologies.
					After five years of sustained R&D investment, we have integrated satellite remote sensing, UAV low-altitude patrols, ground IoT sensing, and the Guangjiliang large model algorithm to establish a four-in-one data collection and analysis system encompassing "space-air-ground-application." This system provides local governments with agricultural condition monitoring and disaster early warning support, offers standardized planting management tools for agricultural business entities, and builds a digital collaboration platform for industry, socialized service organizations, and financial institutions. It aims to promote cost reduction and efficiency improvement in agricultural production, intensive resource utilization, and ecological sustainable development, thereby supporting the implementation of the rural revitalization strategy.
				</div>
			</div>
		</div>
	<!-- 	<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E4%BD%8E%E7%A9%BA%E9%81%A5%E6%84%9F/%E5%A4%B4%E9%83%A8%E5%B9%BF%E5%91%8A%E6%9D%A1.png"
			alt="" />

		<div class="desc">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;千广科技作为智慧农业领域的国资专精特新企业，低空技术+农业应用通过天空地一体化遥感监测、人工智能算法及大数据分析技术，构建覆盖农业生产全链条的数字化管理平台。
		</div>
		<div class="desc">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过五年的持续研发投入，整合卫星遥感、无人机低空巡查、地面物联感知和广积粮大模型算法，形成“天空地用”四位一体数据采集、分析体系，为地方政府提供农情监测与灾害预警支持，为农业经营主体提供标准化种植管理工具，为行业、社会化服务组织及金融机构搭建数字化协作平台，实现推动农业生产降本增效、资源集约利用与生态可持续发展，助力乡村振兴战略实施。
		</div> -->
		<div class="title" style="margin-top: 30px;margin-bottom: 5px;">种植基地数字化</div>
		<img style="width: 60%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E4%BD%8E%E7%A9%BA%E9%81%A5%E6%84%9F/%E7%A7%8D%E6%A4%8D%E5%9F%BA%E5%9C%B0%E6%95%B0%E5%AD%97%E5%8C%96.png"
			alt="" />
		<img style="width: 60%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E4%BD%8E%E7%A9%BA%E9%81%A5%E6%84%9F/%E7%A7%91%E5%AD%A6%E5%88%86%E5%8C%BA.png"
			alt="" />
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">生长过程监测</div>
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E4%BD%8E%E7%A9%BA%E9%81%A5%E6%84%9F/%E7%94%9F%E9%95%BF%E8%BF%87%E7%A8%8B%E7%9B%91%E6%B5%8B.png"
			alt="" />

		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">生长周期监测</div>
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E4%BD%8E%E7%A9%BA%E9%81%A5%E6%84%9F/%E7%94%9F%E9%95%BF%E5%91%A8%E6%9C%9F%E7%9B%91%E6%B5%8B.png"
			alt="" />


		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E4%BD%8E%E7%A9%BA%E9%81%A5%E6%84%9F/%E5%B9%BF%E5%91%8A%E6%9D%A1.png"
			alt="" />
	</div>
</template>

<script>
</script>

<style scoped>
	.textbg {
		width: 65%;
		background-color: rgba(0, 0, 0, 0.4);
		border-radius: 10px;
		padding: 20px;
	}

	.top-bg {
		width: 100%;
		height: 800px;
		background-image: url('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E4%BD%8E%E7%A9%BA%E9%81%A5%E6%84%9F/28a80f5ad1fc2ea2e0a1c7a5dd8fda84.png');
		background-size: 100% 100%;
	}

	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 70%;
		font-size: 22px;
		margin-top: 20px;
		color: rgb(122 169 92);
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>